import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const contacttitle = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/organization/{profile}/contact-title',
    pk: 'code',
    app: 'organization'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'organization', model: 'contacttitle' }
    ),
    { }
  )
)()

export { contacttitle, TYPES }
